/**
 * 기술 지원 FAQ 데이터
 * 브라우저 호환성, 성능 최적화, 문제 해결 가이드
 */

export const technicalFaq = [
  {
    id: 'technical-001',
    category: 'technical',
    question: '지원되는 브라우저는 어떤 것들이 있나요?',
    answer: `
      <h3>권장 브라우저</h3>
      <p>최신 Chrome을 권장해요. Firefox, Safari, Edge 최신 버전도 쓸 수 있어요.</p>

      <h4>편하게 쓰는 환경</h4>
      <ul>
        <li>데스크톱이나 노트북</li>
        <li>안정된 인터넷</li>
        <li>브라우저를 최신으로 유지</li>
      </ul>

      <h4>잘 안 될 때</h4>
      <ul>
        <li>느리면 캐시를 지워 보세요.</li>
        <li>화면이 안 뜨면 새로고침해요.</li>
        <li>기능이 깨지면 다른 브라우저로 열어 보세요.</li>
        <li>계속되면 채널톡 또는 angel@plactical.com으로 문의해요.</li>
      </ul>
    `,
    tags: ['브라우저 호환성', 'Chrome', 'Safari', 'Firefox', '성능', '최적화'],
    relatedFaqs: ['technical-003', 'getting-started-004'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈 브라우저 안내',
    seoDescription: '왓퀴즈 권장 브라우저와 로딩·기능 오류가 났을 때 확인할 점을 안내합니다.'
  },

  {
    id: 'technical-003',
    category: 'technical',
    question: '로그인이 안 되거나 계정 문제가 있어요. 어떻게 해결하나요?',
    answer: `
      <h3>로그인 문제</h3>
      <p>대부분은 브라우저 설정이나 구글 계정 상태 때문이에요.</p>

      <h4>순서대로 확인</h4>
      <ol>
        <li>시크릿(사생활 보호) 창에서 다시 로그인해요.</li>
        <li>왓퀴즈 쿠키와 구글 로그인 팝업을 허용해요.</li>
        <li>캐시와 쿠키를 지운 뒤 다시 시도해요.</li>
        <li>다른 브라우저나 다른 기기에서 열어 보세요.</li>
        <li>gmail.com에 들어가 구글 계정이 정상인지 확인해요.</li>
      </ol>

      <h4>구글 계정 쪽 문제</h4>
      <ul>
        <li>계정이 중지됐다면 myaccount.google.com에서 상태를 봐요.</li>
        <li>2단계 인증이 켜져 있으면 휴대폰 인증을 완료해요.</li>
        <li>비밀번호를 바꿨다면 구글에서 다시 로그인해요.</li>
      </ul>

      <h4>그래도 안 될 때</h4>
      <p>사용 브라우저, 보이는 오류, 시도한 방법을 적어 채널톡 또는 angel@plactical.com으로 보내 주세요. 비밀번호는 보내지 않아도 돼요.</p>
    `,
    tags: ['로그인 오류', '구글 계정', '브라우저 설정', '계정 문제', '인증 오류'],
    relatedFaqs: ['technical-001', 'getting-started-002'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈 로그인 문제 해결',
    seoDescription: '구글 로그인이 안 될 때 브라우저·계정 확인 순서와 문의 방법을 안내합니다.'
  },

  {
    id: 'technical-004',
    category: 'technical',
    question: 'PRO인데 FREE로 보이거나 이용권 확인이 안 돼요.',
    answer: `
      <h3>이용권 연결 문제 해결 방법</h3>

      <p>
        광고 차단 앱, VPN, 학교 보안망이 왓퀴즈의 이용권 확인 요청을 막으면
        결제한 PRO 이용권도 잠시 확인되지 않을 수 있어요. 이용권이 사라진 것은 아니며,
        연결이 복구되면 다시 정상적으로 표시돼요.
      </p>

      <h4>가장 빠른 해결 방법</h4>
      <ol>
        <li>유니콘 Pro 또는 사용 중인 광고 차단 앱을 열어주세요.</li>
        <li>
          왓퀴즈를 사용하는 동안 보호를 잠시 끄거나
          <strong>차단 및 허용</strong> 메뉴에서 왓퀴즈 연결을 허용해주세요.
        </li>
        <li>왓퀴즈 화면으로 돌아와 <strong>다시 확인</strong>을 눌러주세요.</li>
      </ol>

      <div class="mobile-tips">
        <h4>아이폰·아이패드</h4>
        <ul>
          <li>Safari 보호를 사용 중이면 왓퀴즈 사이트에서 콘텐츠 차단을 잠시 꺼주세요.</li>
          <li>
            DNS 보호를 사용 중이면 유니콘 Pro의 <strong>활동</strong>에서
            방금 차단된 왓퀴즈 요청을 선택해 허용해주세요.
          </li>
        </ul>

        <h4>Mac·Windows·Android</h4>
        <ul>
          <li>유니콘 Pro의 <strong>화이트리스트</strong> 또는 <strong>차단 및 허용</strong> 메뉴를 열어주세요.</li>
          <li>먼저 <strong>whatquiz.co.kr</strong>을 허용하고 왓퀴즈로 돌아와 다시 확인해주세요.</li>
        </ul>
      </div>

      <h4>그래도 연결되지 않을 때</h4>
      <p>
        DNS 보호가 별도 API 주소를 막는 경우에는 유니콘 Pro 활동 기록에서
        <strong>quiz-api-397277209875.us-central1.run.app</strong> 요청을 허용해주세요.
        전체 광고 차단을 계속 꺼둘 필요는 없어요.
      </p>

      <p>
        메뉴 이름은 유니콘 Pro 버전과 기기에 따라 조금 다를 수 있어요.
        자세한 제품별 설정은
        <a href="https://support.getunicorn.app/hc/ko" target="_blank" rel="noopener noreferrer">
          유니콘 공식 도움말
        </a>
        에서 확인할 수 있어요.
      </p>

      <div class="support-contact">
        <p>
          계속 해결되지 않으면 사용 기기, 브라우저, 문제가 발생한 시간을 적어
          <strong>angel@plactical.com</strong>으로 보내주세요.
          비밀번호나 결제정보는 보내지 않아도 돼요.
        </p>
      </div>
    `,
    tags: ['PRO 확인 실패', 'FREE 표시', '유니콘 Pro', '광고 차단', 'VPN', '학교 보안망'],
    relatedFaqs: ['technical-001', 'technical-003'],
    lastUpdated: '2026-08-19',
    seoTitle: '왓퀴즈 PRO 이용권 확인 실패 해결 방법',
    seoDescription: '유니콘 Pro, 광고 차단 앱, VPN 또는 학교 보안망 때문에 왓퀴즈 PRO 이용권이 확인되지 않을 때 해결하는 방법입니다.'
  }
];

// FAQ 검색 함수
export const searchTechnicalFaq = (query) => {
  const searchTerm = query.toLowerCase();
  return technicalFaq.filter(faq => 
    faq.question.toLowerCase().includes(searchTerm) ||
    faq.answer.toLowerCase().includes(searchTerm) ||
    faq.tags.some(tag => tag.toLowerCase().includes(searchTerm))
  );
};

// ID로 FAQ 찾기
export const getTechnicalFaqById = (id) => {
  return technicalFaq.find(faq => faq.id === id);
};

// 연관 FAQ 가져오기
export const getRelatedTechnicalFaqs = (currentFaqId) => {
  const currentFaq = getTechnicalFaqById(currentFaqId);
  if (!currentFaq || !currentFaq.relatedFaqs) return [];
  
  return currentFaq.relatedFaqs.map(id => getTechnicalFaqById(id)).filter(Boolean);
};
